/**
 * Auth context. Wraps the app and exposes the current principal (or null) + loading state, derived
 * from the `me` query. Route guards and the header read this via `useAuth()`.
 */
import { createContext, useContext, type ReactNode } from "react";
import { useMe, type AuthUser } from "../api/auth";

interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
}

const AuthContext = createContext<AuthState>({ user: null, isLoading: true });

export function AuthProvider({ children }: { children: ReactNode }) {
  const me = useMe();
  return (
    <AuthContext.Provider value={{ user: me.data ?? null, isLoading: me.isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthState {
  return useContext(AuthContext);
}
